var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('v-main',{staticClass:"pt-0 pt-sm-0 pt-xs-0 pt-md-0 pt-lg-0 pt-xl-0 main",attrs:{"id":"skip-here"}},[_c('v-container',[_c('h1',[_vm._v("404: Page not Found!")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }